<template>
    <div>
        <span class="is-description mr-2">
            <span class="icon">
                <i class="fas fa-tag"></i>
            </span>
            <span>{{ translate("pricing.fixed_price_for_single_category") }}:</span>
        </span>

        <span v-for="(price, index) in prices" :key="index" class="tag is-info mr-1"> {{ price.value }} {{ price.currency }} </span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { FixedPriceForSingleCategoryRawAttribute } from "../../Common/Pricing/types";
    import { translate } from "../../Common/translations";

    const props = defineProps<{
        attribute: FixedPriceForSingleCategoryRawAttribute;
    }>();

    const prices = computed(() => {
        return props.attribute.value.map(([price, currency]) => {
            return {
                value: price,
                currency: currency,
            };
        });
    });
</script>

<style scoped></style>
